import Request from "../../../helpers/Request";
import LanguageHelper from "../../../helpers/LanguageHelper";
import moment from "moment";

export default function FetchData(
  query,
  setSnackbar,
  setSnackbarMessage,
  setSeverity,
  setNumOfEntries,
  type,
  filterProps
) {

  const language = LanguageHelper.getLanguage();
  const data = new Promise(async (resolve, reject) => {
    const params = {
      page: query.page,
      size: query.pageSize,
      sort: "id,desc",
    };
    if (query.orderBy !== undefined) {
      if (query.orderBy.field === "id") {
        params.sort = "id," + query.orderDirection;
      } else if (query.orderBy.field === "fullName") {
        params.sort = "fName,lName," + query.orderDirection;
      } else if (query.orderBy.field === "departmentName") {
        params.sort = "department.name," + query.orderDirection;
      } else if (query.orderBy.field === "branchName") {
        params.sort = "branch.name," + query.orderDirection;
      } else if (query.orderBy.field === "company") {
        params.sort = "company.name," + query.orderDirection;
      } else if (query.orderBy.field === "title") {
        params.sort = "title," + query.orderDirection;
      } else if (query.orderBy.field === "email") {
        params.sort = "email," + query.orderDirection;
      } else if (query.orderBy.field === "enabled") {
        params.sort = "enabled," + query.orderDirection;
      } else if (query.orderBy.field === "managerName") {
        params.sort = "manager.fName,manager.lName," + query.orderDirection;
      } else if (query.orderBy.field === "userSGKNo") {
        params.sort = "userSGKNo," + query.orderDirection;
      } else if (query.orderBy.field === "tcNo") {
        params.sort = "tcNo," + query.orderDirection;
      } else if (query.orderBy.field === "birthDate") {
        params.sort = "birthDate," + query.orderDirection;
      } else if (query.orderBy.field === "phoneNo") {
        params.sort = "phoneNo," + query.orderDirection;
      } else if (query.orderBy.field === "dailyHourOfWork") {
        params.sort = "dailyHourofWork," + query.orderDirection;
      } else if (query.orderBy.field === "maritalStatus") {
        params.sort = "maritalStatus.nameTr," + query.orderDirection;
      } else if (query.orderBy.field === "gender") {
        params.sort = "gender.nameTr," + query.orderDirection;
      } else if (query.orderBy.field === "startDateOfWork") {
        params.sort = "startDateOfWork," + query.orderDirection;
      } else if (query.orderBy.field === "didGetISGTraining") {
        params.sort = "didGetISGTraining," + query.orderDirection;
      }
    }
    if (query.search !== "") {
      params.search = query.search;
    }
    const resp = await Request("get", "/api/users", null, params);
    if (resp.status !== 200) {
      setSeverity("error");
      setSnackbarMessage(language.etc.fetchingError + resp?.data?.message);
      setSnackbar(true);
    } else {
      let otherData = resp.data;
      let data = otherData.content;
      let temp = [];
      for (let i = 0; i < data.length; i++) {
        const edit = {
          deletedAt: data[i].deletedAt
            ? moment(data[i].deletedAt).format("DD.MM.YYYY")
            : null,
          isActive: data[i].isActive ? data[i].isActive : null,
          id: data[i].id ? data[i].id : null,
          firstName: data[i].fName ? data[i].fName : null,
          lastName: data[i].lName ? data[i].lName : null,
          fullName:
            data[i].fName && data[i].lName
              ? data[i].fName + " " + data[i].lName
              : "Yok",
          title: data[i].title ? data[i].title : null,
          email: data[i].email ? data[i].email : null,
          enabled: data[i].enabled ? data[i].enabled : null,
          roles: data[i].roles ? formatRoles(data[i].roles) : null,
          permissions: data[i].permissions ? formatPermissions(data[i].permissions) : null,
          phoneNo: data[i].phoneNo ? data[i].phoneNo : null,
        };
        temp.push(edit);
      }
      setNumOfEntries(otherData.totalElements);
      resolve({
        data: temp,
        page: otherData.pageable.pageNumber,
        totalCount: otherData.totalElements,
      });
    }
  });
  return data;
}

const formatRoles = (roles) => {
  let newArray = [];
  for (let i = 0; i < roles.length; i++) {
    newArray.push(roles[i].name);
  }
  return newArray;
};

const formatPermissions = (permissions) => {
    let newArray = [];
    for (let i = 0; i < permissions.length; i++) {
        newArray.push(permissions[i].name);
    }
    return newArray;
}
